import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/acesso/usuarios/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findUsuarios(empresa_cnpj, id, include = "") {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findPermissionsForOrder({ empresa_cnpj, userId }) {
  return search(
    `${path}/get-user-permissions-for-order?empresa_cnpj=${empresa_cnpj}${
      userId ? `&idusuario=${userId}` : ""
    }`,
    "GET",
    headers
  );
}

export async function authenticateUserWithPermissions({ empresa_cnpj, body }) {
  return search(
    `${path}/authenticate-user-with-permissions?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}

export async function authenticateUserDiscount({ empresa_cnpj, body }) {
  return search(
    `${path}/authenticate-user-discount?empresa_cnpj=${empresa_cnpj}`,
    "POST",
    headers,
    body
  );
}
